// Auth
export const AUTH_RESET_PASSWORD_REQUEST = "/auth/password_reset";
